import { timeAgo } from "../lib/format";

/**
 * Unobtrusive "Last Updated / Data Status" indicator.
 * Driven ENTIRELY by data the app already fetched (updated_at + stale + query error).
 * Makes NO network request of its own.
 *   green  → data current
 *   amber  → using cached data (provider temporarily unavailable or gated)
 *   red    → data temporarily unavailable (request failed, nothing cached)
 */
export function DataStatus({ updatedAt, stale = false, error = false, className = "", testid }) {
  let color, label;
  if (error && !updatedAt) {
    color = "bg-red-500";
    label = "Data temporarily unavailable";
  } else if (stale) {
    color = "bg-amber-500";
    label = updatedAt ? `Updated ${timeAgo(updatedAt)} · Cached` : "Using cached data";
  } else if (updatedAt) {
    color = "bg-emerald-500";
    label = `Updated ${timeAgo(updatedAt)}`;
  } else {
    return null;
  }

  return (
    <span
      data-testid={testid}
      title={label}
      className={`inline-flex items-center gap-1.5 text-xs text-muted-foreground font-mono ${className}`}
    >
      <span className={`h-2 w-2 rounded-full ${color} ${stale ? "animate-pulse" : ""}`} aria-hidden />
      <span className="whitespace-nowrap">{label}</span>
    </span>
  );
}
